import { boot } from 'quasar/wrappers'
import axios from 'axios'
import qs from 'qs'
import { getAuth, signInWithCustomToken } from 'firebase/auth'
import { Preferences } from '@capacitor/preferences';
import { Platform } from 'quasar'

export default boot(({ router, store, app }) => {
	app.config.globalProperties.$axios = axios

	axios.defaults.baseURL = process.env.API_URL
	axios.defaults.timeout = 0

	axios.interceptors.request.use(
		async (config) => {
			const access_token_query = new URLSearchParams(window.location.href.split('?')[1]).get('access_token')
			let access_token = store.getters['common/access_token']
			if (Platform.is.capacitor && Platform.is.ios && !window.location.href.includes('/youtube-iframe')) {
				try {
					const prefRes = await Preferences.get({ key: 'access_token' });
					if (prefRes && prefRes.value) {
						access_token = prefRes.value;
					}
				} catch (e) {
					console.error("Preferences error:", e)
				}
			}
			const access_token_store = access_token
			if (
				config.url.includes('o/token/')
			) {
				config.headers['content-type'] = 'application/x-www-form-urlencoded'
				config.headers['authorization'] = `Basic ${btoa(
					process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET
				)}`
			} else if (config.url.includes('/get_trail_user_result_certificate/')) {
				config.headers['content-type'] = 'application/x-www-form-urlencoded'
				config.headers['authorization'] = `Bearer ${access_token_store}`
			} else if (
				config.data &&
				config.data instanceof FormData &&
				!config.url.includes('/api/files/complete/') &&
				!config.url.includes(process.env.BUCKET_URL)
			) {
				config.headers['content-type'] = 'multipart/form-data'
				config.headers['authorization'] = `Bearer ${access_token_store}`
			} else if (config.url.includes('/etraining_login/api_recover_password/')) {
				config.headers['content-type'] = 'application/json'
			} else if (config.url.includes('/etraining_login/get_phone_number_with_document/')) {
				config.headers['content-type'] = 'application/json'
			} else if (config.url.includes('/etraining_login/send_recover_password_code/')) {
				config.headers['content-type'] = 'application/json'
			} else if (config.url.includes('/etraining_login/validate_recover_password_code/')) {
				config.headers['content-type'] = 'application/json'
			} else if (config.url.includes('/accounts/reload_user_tokens/')) {
				config.headers['content-type'] = 'application/json'
				config.headers['authorization'] = `Basic ${btoa(
					process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET
				)}`
				config.headers['authorization'] = `Bearer ${access_token_store}`
			} else if (access_token_store && !config.url.includes('https://')) {
				config.headers['content-type'] = 'application/json'
				config.headers['authorization'] = `Bearer ${access_token_store}`
			} else if (access_token_query) {
				config.headers['content-type'] = 'application/json'
				config.headers['authorization'] = `Bearer ${access_token_query}`
			} else if (!config.url.includes('https://')) {
				config.headers['content-type'] = 'application/json'
				config.headers['authorization'] = `Basic ${btoa(
					process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET
				)}`
			}

			return config
		},

		(error) => {
			console.error('Request error:', error)
			return Promise.reject(error)
		}
	)

	refreshToken(axios, router, store)
})

export { axios }

function refreshToken(instance, router, store) {
	var isRefreshing = false
	var subscribers = []

	function subscribeTokenRefresh(cb) {
		subscribers.push(cb)
	}

	function onRrefreshed(token) {
		subscribers.map((cb) => cb(token))
	}

	instance.interceptors.response.use(undefined, (err) => {
		const {
			config,
			response: { status },
		} = err
		const originalRequest = config

		if (
			status === 401 &&
			store.getters['common/refresh_token'] &&
			!store.getters['common/webservice_token'] &&
			process.env.PROJECT_FOLDER !== 'itpiry'
		) {
			if (!isRefreshing) {
				isRefreshing = true

				let data = {
					grant_type: 'refresh_token',
					refresh_token: store.getters['common/refresh_token'],
				}

				let headers = {
					headers: {
						'content-type': 'application/x-www-form-urlencoded',
						authorization: `Basic ${btoa(
							process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET
						)}`,
					},
				}

				instance
					.post('/o/token/', qs.stringify(data), headers)
					.then((response) => {
						store.dispatch('common/SET_ACCESS_TOKEN', [
							response.data.access_token,
							response.data.refresh_token,
							response.data.user_firebase_token,
						])

						if (response.data.user_firebase_token) {
							const auth = getAuth()
							signInWithCustomToken(auth, response.data.user_firebase_token)
								.then(() => {
									isRefreshing = false
									onRrefreshed(response.data.access_token)
									subscribers = []
								})
								.catch((error) => {
									console.log(e)
								})
						} else {
							isRefreshing = false
							onRrefreshed(response.data.access_token)
							subscribers = []
						}
					})
					.catch((e) => {
						store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])
						store.dispatch('common/SET_DATE_REQUEST_USER_DATA', [''])
						router.replace({ name: 'login' })
						console.log(e)
					})
			}
			const requestSubscribers = new Promise((resolve) => {
				subscribeTokenRefresh((token) => {
					// originalRequest.headers = {}
					// originalRequest.headers.Authorization = `Bearer ${token}`
					resolve(axios(originalRequest))
				})
			})
			return requestSubscribers
		} else if (
			(status === 401 &&
				!store.getters['common/refresh_token'] &&
				!store.getters['common/webservice_token']) ||
			process.env.PROJECT_FOLDER === 'itpiry'
		) {
			store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])
			store.dispatch('common/SET_DATE_REQUEST_USER_DATA', [''])
			router.replace({ name: 'login' })
		} else if (status === 401 && store.getters['common/webservice_token']) {
			store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])
			store.dispatch('common/SET_DATE_REQUEST_USER_DATA', [''])
			store.dispatch('common/SET_WEBSERVICE_TOKEN', [''])
			router.replace({ name: 'login' })
		}
		return Promise.reject(err)
	})
}

